import "./BtnApps.css";

const play = "https://play.google.com/store/apps/details?id=com.jadaara.personaltrainer";
const appstor = "https://apps.apple.com/us/app/personal-trainer-app/id6477526776";

export default function BtnsApps() {
  return (
    <div className="btns-download">
      <a href={play} target="_blank" rel="noopener noreferrer">
        <img src="/images/play.png" alt="google_play" />
        <img src="/images/iconPlay.png" alt="google_play" />
      </a>
      <a href={appstor} target="_blank" rel="noopener noreferrer">
        <img src="/images/app.png" alt="App_stor" />
        <img src="/images/iconApp.png" alt="App_stor" />
      </a>
    </div>
  );
}